<template>
  <div class="feedback">
    <button @click="feedback_dialog = true" class="feedback-button">
      Feedback
    </button>
    <v-dialog v-model="feedback_dialog" max-width="600">
      <div style="background: #ffffff; border-radius: 20px">
        <v-card style="padding: 10px">
          <a
            style="float: right"
            class="button"
            @click="feedback_dialog = false"
          >
            <v-icon>close</v-icon>
          </a>
          <h4 style="font-weight: bold">
            How would you rate our buying experience?
          </h4>
          <vue-feedback-reaction
            v-model="feedback"
            :labels="labels"
            emojiWidth="inherit"
          />
          <h4>Please feel free to leave any comments below.</h4>
          <textarea
            v-model="client_comments"
            placeholder="Add comments here..."
            style="
              border: 2px solid grey;
              border-radius: 5px;
              width: 80%;
              height: 100px;
              color: black;
              font-size: 15px;
            "
          ></textarea>
          <p style="color: red" v-if="errorMessage">
            *Please provide the feedback before proceeding
          </p>
          <br />
          <v-btn small color="#6dbe45" @click="submitFeedback()">SUBMIT</v-btn>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { VueFeedbackReaction } from "vue-feedback-reaction";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "demo",
  components: {
    VueFeedbackReaction,
  },
  computed: {
    ...mapGetters({
      containers_list: types.CONTAINER_LIST,
      CART: types.CART_LIST,
      cscTerms: types.CSC_TERMS,
      currentSurvey: types.CURRENTSURVEYOBJECT,
    }),
  },
  data: () => ({
    labels: ["Awful", "Bad", "Fine", "Good", "Excellent"],
    client_comments: "",
    feedback: null,
    errorMessage: false,
    feedback_dialog: false,
  }),
  methods: {
    ...mapActions({
      updateFeedbackGiven: types.ACTIONS_UPDATE_FEEDBACKGIVEN,
    }),
    submitFeedback() {
      if (this.feedback) {
        this.errorMessage = false;
        var clients_location =
          this.containers_list.customerInfo.DeliveryCity ||
          localStorage.zipcode ||
          "Not found";

        const feedbackAttributes = {
          client_id: localStorage.userFeedSessionId,
          additional_comments: this.client_comments,
          rating: this.feedback,
          clients_location: clients_location,
          createdAt: new Date().toString(),
        };

        const url =
          "https://8bikxb8159.execute-api.us-west-2.amazonaws.com/prod/updatefeedbackdatabase";
        var headers_list = {
          "X-API-Key": "Wh800Bmzos3MRE52jwZQA8mmTMDIvOngaIi0uqSo",
          "content-type": "application/json",
        };
        axios
          .post(url, feedbackAttributes, { headers: headers_list })
          .then(() => {
            this.$toast("Thank you for your feedback!", {
              id: "auto",
              type: "info",
              position: "top-center",
            });
            this.updateFeedbackGiven(true);
          })
          .catch((err) => {
            console.log(err);
            this.updateFeedbackGiven(true);
          });
      } else this.errorMessage = true;
    },
  },
};
</script>

<style scoped>
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css);

.feedback {
  display: block;
  margin: auto;
  color: black;
  font-size: 12px;
  width: 90%;
  padding: 8px;
}

h4 {
  font-size: 18px;
}

@media only screen and (max-width: 880px) {
  h4 {
    font-size: 15px;
  }

  .feedback {
    font-size: 10px;
  }
}

@media screen and (max-width: 480px) {
  .feedback {
    width: 100%;
  }
}

.feedback-button {
  height: 40px;
  width: 100px;
  background: #6dbe45;
  border-radius: 5px;
  border: 2px solid white;
  line-height: 32px;
  -webkit-transform: rotate(-90deg);
  font-weight: 600;
  color: black;
  transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  text-align: center;
  font-size: 17px;
  position: fixed;
  right: -40px;
  top: 45%;
  font-family: "Roboto", helvetica, arial, sans-serif;
  z-index: 999;
}
</style>
